export default {
  tts: {
    viewHistory: '查看历史记录',
    viewTextList: '查看文本列表',
    inputPlaceholder: '请输入要转换为音频的文字',
    save: '保存',
    play: '播放',
    textList: '文本列表',
    noTextData: '暂无文本数据',
    ttsHistoryList: 'TTS历史播放列表',
    saveSuccess: '保存成功',
    confirmDelete: '请确认是否删除该条数据',
    repeatPlaySuccess: '重复播放成功',
    settingSuccess: '设置成功',
    speaking: '正在喊话',
    volumeChangeSuccess: '修改音量成功',
    micNotSupported: '浏览器不支持音频输入',
    permissionDenied: '用户拒绝提供信息。',
    hardwareNotSupported: '浏览器不支持硬件设备。',
    deviceNotFound: '无法发现指定的硬件设备。',
    micOpenFailed: '无法打开麦克风。异常信息:{info}',
    recordSuffix: '录音',
    statusIdle: '空闲着',
    statusPlaying: '正在播放',
    statusRecording: '正在录音',
    statusFree: '空闲中',
    none: '无',
  },
  speak: {
    recordShout: '录音喊话',
    localPreview: '本地试听',
    upload: '上传',
    shout: '喊话',
    reRecord: '重录',
    startRecord: '开始录音',
    textConvertInput: '文本转换录入',
    singlePlaySuccess: '设置单次播放成功',
    singleLoopSuccess: '设置单次循环成功',
    uploadSuccess: '上传成功',
    micOpenFailedShort: '无法打开麦克风。',
  },
  list: {
    audioList: '音频列表',
    audioImport: '音频导入',
    noAudioData: '暂无音频数据',
    converting: '音频转换中',
    importSuccess: '导入成功',
  },
}
